module.exports = __webpack_public_path__ + "static/media/stroke.3b9c3b38.mp3";